import { render, staticRenderFns } from "./NoProtocolDiagnosticTrendChart.vue?vue&type=template&id=590e66ec"
import script from "./NoProtocolDiagnosticTrendChart.vue?vue&type=script&lang=js"
export * from "./NoProtocolDiagnosticTrendChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports